var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0003 16C14.6572 16 16.0003 14.6569 16.0003 13C16.0003 11.3431 14.6572 10 13.0003 10C11.3435 10 10.0003 11.3431 10.0003 13C10.0003 14.6569 11.3435 16 13.0003 16ZM13.0003 15C14.1049 15 15.0003 14.1046 15.0003 13C15.0003 11.8954 14.1049 11 13.0003 11C11.8958 11 11.0003 11.8954 11.0003 13C11.0003 14.1046 11.8958 15 13.0003 15Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4648 19.4645C10.4025 18.5268 11.6742 18 13.0003 18C14.3264 18 15.5982 18.5268 16.5359 19.4645C17.3551 20.2837 17.8607 21.3581 17.9754 22.5008C18.0029 22.7756 18.2242 23 18.5003 23C18.7765 23 19.0025 22.7757 18.9795 22.5005C18.8619 21.0922 18.2499 19.7643 17.243 18.7574C16.1178 17.6321 14.5916 17 13.0003 17C11.409 17 9.88291 17.6321 8.75769 18.7574C7.7508 19.7642 7.13874 21.0922 7.02114 22.5005C6.99816 22.7757 7.22419 23 7.50033 23C7.77647 23 7.99774 22.7756 8.0253 22.5008C8.13992 21.3581 8.64552 20.2837 9.4648 19.4645Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8583 19.1665C18.6647 18.8713 18.4494 18.5916 18.2147 18.3297C18.7794 18.1138 19.384 18 20.0003 18C21.3264 18 22.5982 18.5268 23.5359 19.4645C24.3552 20.2837 24.8608 21.3581 24.9754 22.5008C25.0029 22.7756 24.7765 23 24.5003 23C24.2242 23 24.0036 22.7753 23.9691 22.5013C23.859 21.6243 23.4604 20.8032 22.8288 20.1716C22.0786 19.4214 21.0612 19 20.0003 19C19.6101 19 19.2257 19.057 18.8583 19.1665Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0003 15C22.0003 16.1046 21.1049 17 20.0003 17C18.8958 17 18.0003 16.1046 18.0003 15C18.0003 13.8954 18.8958 13 20.0003 13C21.1049 13 22.0003 13.8954 22.0003 15ZM21.0003 15C21.0003 15.5523 20.5526 16 20.0003 16C19.448 16 19.0003 15.5523 19.0003 15C19.0003 14.4477 19.448 14 20.0003 14C20.5526 14 21.0003 14.4477 21.0003 15Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.593fd939650f4449a28c9a21858e30cd.svg";
export { ForwardRef as ReactComponent };